export default {
  init() {
    // JavaScript to be fired on all pages
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired

    // Close navbar after clicking on nav-link
    const navLi = document.querySelectorAll('.mega-menu-item');
    const navbarToggler = document.querySelectorAll('.mega-menu-toggle')

    if ( window.outerWidth < 1080 ) {
      navLi.forEach((li) => {
        li.addEventListener('click', () => {
          console.log('click');
          navbarToggler[0].classList.remove('mega-menu-open');
        })
      })
    }


    // Adjust the header if the user is in the wp admin
    let wpAdminBar = document.getElementById('wpadminbar');

    if ( wpAdminBar ) {
      let header = document.getElementsByTagName('header')[0];
      header.classList.add('wpAdminBarPresent');
    }


    // Check the scroll position
    window.addEventListener('scroll', () => {

      let header = document.getElementsByTagName('header')[0];

      if (document.body.scrollTop > 55 || document.documentElement.scrollTop > 55) {
        if ( !(header.classList.contains('scrolled')) ) {
          header.classList.add('scrolled');
        }
      } else {
        if ( header.classList.contains('scrolled') ) {
          header.classList.remove('scrolled');
        }
      }

    }, { passive: true });


    // Events carousel - home
    if ($('.events-carousel-items').length) {
      $('.events-carousel-items').slick({
        infinite: true,
        slidesToShow: 4,
        autoplay: false,
        dots: false,
        arrows: true,
        appendArrows: '.events-carousel-controls',
        responsive: [
          {
            breakpoint: 1530,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
            },
          },
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
            },
          },
          {
            breakpoint: 810,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      });
    }


    // About us page
    // Button to expand the our history text
    let ourHistoryButton = $('#history-button');

    ourHistoryButton.on('click', () => {
      let collapsedText = document.getElementsByClassName('collapsed-text')[0];
      
      ourHistoryButton[0].classList.remove('active');
      collapsedText.classList.remove('d-none');

      setTimeout(() => {
        collapsedText.classList.add('active');
        ourHistoryButton[0].classList.add('d-none');
      }, 300)
    });

    // Slick slider for montezuma gallery
    if ($('.gallery-pictures-items').length) {
      $('.gallery-pictures-items').slick({
        infinite: false,
        rows: 3,
        slidesPerRow: 3,
        slidesToScroll: 1,
        autoplay: false,
        dots: true,
        adaptiveHeight: true,
        responsive: [
          {
            breakpoint: 1080,
            settings: {
              rows: 2,
              slidesPerRow: 2,
            },
          },
          {
            breakpoint: 768,
            settings: {
              rows: 1,
              slidesPerRow: 2,
            },
          },
          {
            breakpoint: 576,
            settings: {
              rows: 1,
              slidesPerRow: 1,
            },
          },
        ],
      });
    }

    function openGalleryModal(e) {
      $('body').css({overflowY: 'hidden'});
      let carouselModal = document.querySelector('.carousel-image-modal');
      let prevIcon = document.getElementsByClassName('gallery-modal-picture-prev')[0];
      let nextIcon = document.getElementsByClassName('gallery-modal-picture-next')[0];
      
      if ( carouselModal.classList.contains('d-none') ) {
        carouselModal.classList.remove('d-none');
      }
      
      setTimeout(() => carouselModal.classList.add('active'), 300);

      if ( prevIcon.classList.contains('d-none') ) {
        prevIcon.classList.remove('d-none');
      }
      
      if ( nextIcon.classList.contains('d-none') ) {
        nextIcon.classList.remove('d-none');
      }

      carouselModal.children[0].children[0].src = e.target.dataset.imagePath;
      carouselModal.children[0].children[0].dataset.currentImage = e.target.dataset.imageNumber;

      // Disable previous button if first image is selected
      if ( e.target.dataset.imageNumber === '0' && ( !(prevIcon.classList.contains('d-none')) )) {
        prevIcon.classList.add('d-none');
      }

      // Disable next button if last image is selected
      if ( e.target.dataset.hasOwnProperty('lastPicture') && ( !(nextIcon.classList.contains('d-none')) )) {
        nextIcon.classList.add('d-none');
      }
    }

    function previousPictureModal() {
      let modalImage = document.querySelector('.carousel-image-wrapper').children[0];
      let previousImageIndex = Number(modalImage.dataset.currentImage) - 1;
      let previousImage = document.querySelector(`.gallery-pictures-item [data-image-number="${previousImageIndex}"]`);
      let nextIcon = document.getElementsByClassName('gallery-modal-picture-next')[0];
      
      modalImage.src = previousImage.dataset.imagePath;
      modalImage.dataset.currentImage = previousImageIndex;

      // Enable next icon
      if ( nextIcon.classList.contains('d-none') ) {
        nextIcon.classList.remove('d-none');
      }

      // Disable previous button if first image is selected
      if ( modalImage.dataset.currentImage === '0' ) {
        let prevIcon = document.getElementsByClassName('gallery-modal-picture-prev')[0];

        if ( !(prevIcon.classList.contains('d-none')) ) {
          prevIcon.classList.add('d-none');
        }
      }
    }

    function nextPictureModal() {
      let modalImage = document.querySelector('.carousel-image-wrapper').children[0]; 
      let nextImageIndex = Number(modalImage.dataset.currentImage) + 1;
      let nextImage = document.querySelector(`.gallery-pictures-item [data-image-number="${nextImageIndex}"]`);
      let prevIcon = document.getElementsByClassName('gallery-modal-picture-prev')[0];
      
      modalImage.src = nextImage.dataset.imagePath;
      modalImage.dataset.currentImage = nextImageIndex;

      // Enable previous icon
      if ( prevIcon.classList.contains('d-none') ) {
        prevIcon.classList.remove('d-none');
      }

      // Disable previous button if first image is selected
      if ( nextImage.dataset.hasOwnProperty('lastPicture') ) {
        let nextIcon = document.getElementsByClassName('gallery-modal-picture-next')[0];

        if ( !(nextIcon.classList.contains('d-none')) ) {
          nextIcon.classList.add('d-none');
        }
      }
    }

    function closeGalleryModal() {
      let carouselModal = document.querySelector('.carousel-image-modal');

      if ( carouselModal.classList.contains('active') ) {
        carouselModal.classList.remove('active');
      }
      $('body').css({overflowY: 'scroll'});
    }

    // Open image on modal
    $('.gallery-pictures-items .item-image').on('click', openGalleryModal);

    // Go back one picture in modal
    $('.gallery-modal-picture-prev').on('click', previousPictureModal);

    // Go forward one picture in modal
    $('.gallery-modal-picture-next').on('click', nextPictureModal);

    // Close modal - exit button
    $('.carousel-image-modal .modal-close').on('click', closeGalleryModal);

    // Close modal - clicking outside the image
    $('.carousel-image-wrapper').on('click', (e) => {
      if ( e.target.classList.contains('carousel-image-wrapper') ) {
        closeGalleryModal();
      }
    });


    // Apparatus carousel
    if ($('.apparatus-carousel-items').length) {
      $('.apparatus-carousel-items').slick({
        infinite: false,
        slidesToShow: 2,
        slidesToScroll: 2,
        autoplay: false,
        dots: true,
        arrows: true,
        responsive: [
          {
            breakpoint: 1080,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      });
    }

    if ($('.commissioner-carousel-items').length) {
      $('.commissioner-carousel-items').slick({
        infinite: true,
        slidesToShow: 6,
        slidesToScroll: 1,
        arrows: true,
        dots: true,
        autoplay: false,
        prevArrow: '<button class="slide-arrow arrow-left"><i class="fa">&#xf053</i></button>',
        nextArrow: '<button class="slide-arrow arrow-right"><i class="fa">&#xf054</i></button>',
        responsive: [
          {
            breakpoint: 1500,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 1000,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      });
    }

    function openApparatusModal(e) {
      $('body').css({overflowY: 'hidden'});
      let apparatusModal = document.querySelector('.apparatus-carousel-image-modal');
      let prevIcon = document.getElementsByClassName('apparatus-modal-picture-prev')[0];
      let nextIcon = document.getElementsByClassName('apparatus-modal-picture-next')[0];
      
      if ( apparatusModal.classList.contains('d-none') ) {
        apparatusModal.classList.remove('d-none');
      }
      
      setTimeout(() => apparatusModal.classList.add('active'), 300);

      if ( prevIcon.classList.contains('d-none') ) {
        prevIcon.classList.remove('d-none');
      }
      
      if ( nextIcon.classList.contains('d-none') ) {
        nextIcon.classList.remove('d-none');
      }

      var dataElement;
      
      if ( e.target.classList.contains('apparatus-carousel-item-image-wrapper') ) {
        dataElement = e.target;
      } else {
        dataElement = e.target.parentElement;
      }

      apparatusModal.children[0].children[0].src = dataElement.dataset.imagePath;
      apparatusModal.children[0].children[0].dataset.currentImage = dataElement.dataset.imageNumber;

      // Disable previous button if first image is selected
      if ( dataElement.dataset.imageNumber === '0' && ( !(prevIcon.classList.contains('d-none')) )) {
        prevIcon.classList.add('d-none');
      }

      // Disable next button if last image is selected
      if ( dataElement.dataset.hasOwnProperty('lastPicture') && ( !(nextIcon.classList.contains('d-none')) )) {
        nextIcon.classList.add('d-none');
      }
    }

    function previousApparatusPictureModal() {
      let modalImage = document.querySelector('.apparatus-carousel-image-wrapper').children[0];
      let previousImageIndex = Number(modalImage.dataset.currentImage) - 1;
      let previousImage = document.querySelector(`.apparatus-carousel-item [data-image-number="${previousImageIndex}"]`);
      let nextIcon = document.getElementsByClassName('apparatus-modal-picture-next')[0];
      
      modalImage.src = previousImage.dataset.imagePath;
      modalImage.dataset.currentImage = previousImageIndex;

      // Enable next icon
      if ( nextIcon.classList.contains('d-none') ) {
        nextIcon.classList.remove('d-none');
      }

      // Disable previous button if first image is selected
      if ( modalImage.dataset.currentImage === '0' ) {
        let prevIcon = document.getElementsByClassName('apparatus-modal-picture-prev')[0];

        if ( !(prevIcon.classList.contains('d-none')) ) {
          prevIcon.classList.add('d-none');
        }
      }
    }

    function nextApparatusPictureModal() {
      let modalImage = document.querySelector('.apparatus-carousel-image-wrapper').children[0]; 
      let nextImageIndex = Number(modalImage.dataset.currentImage) + 1;
      let nextImage = document.querySelector(`.apparatus-carousel-item [data-image-number="${nextImageIndex}"]`);
      let prevIcon = document.getElementsByClassName('apparatus-modal-picture-prev')[0];
      
      modalImage.src = nextImage.dataset.imagePath;
      modalImage.dataset.currentImage = nextImageIndex;

      // Enable previous icon
      if ( prevIcon.classList.contains('d-none') ) {
        prevIcon.classList.remove('d-none');
      }

      // Disable previous button if first image is selected
      if ( nextImage.dataset.hasOwnProperty('lastPicture') ) {
        let nextIcon = document.getElementsByClassName('apparatus-modal-picture-next')[0];

        if ( !(nextIcon.classList.contains('d-none')) ) {
          nextIcon.classList.add('d-none');
        }
      }
    }

    function closeApparatusModal() {
      let apparatusModal = document.querySelector('.apparatus-carousel-image-modal');

      if ( apparatusModal.classList.contains('active') ) {
        apparatusModal.classList.remove('active');
      }
      $('body').css({overflowY: 'scroll'});
    }

    // Open image on modal
    $('.apparatus-carousel-item-image-wrapper').on('click', openApparatusModal);

    // Go back one picture in modal
    $('.apparatus-modal-picture-prev').on('click', previousApparatusPictureModal);

    // Go forward one picture in modal
    $('.apparatus-modal-picture-next').on('click', nextApparatusPictureModal);

    // Close modal - exit button
    $('.apparatus-modal-close').on('click', closeApparatusModal);

    // Close modal - clicking outside the image
    $('.apparatus-carousel-image-wrapper').on('click', (e) => {
      if ( e.target.classList.contains('apparatus-carousel-image-wrapper') ) {
        closeApparatusModal();
      }
    });


    // Minutes details page
    let singleMinute = document.getElementsByClassName('single-minutes');
    if ( singleMinute.length ) {

      // Rotate the chevron of the active year and month, if it is a button
      let activeYear = document.querySelectorAll('.minutes-archive-year.active');
      if ( activeYear.length ) {
        activeYear[0].children[1].classList.add('open');
      }
      
      let activeMonth = document.querySelectorAll('button.minutes-archive-month.active');
      if ( activeMonth.length ) {
        activeMonth[0].children[1].classList.add('open');
      }
      
      // Rotate the year chevron when toggling the information
      $('.minutes-archive-year').on('click', (e) => {
        var minutesArchiveYearButton;
        
        if ( e.target.tagName === 'BUTTON' ) {
          minutesArchiveYearButton = e.target;
        } else {
          minutesArchiveYearButton = e.target.parentElement;
        }
        
        if ( minutesArchiveYearButton.children[1].classList.contains('open') ) {
          minutesArchiveYearButton.children[1].classList.remove('open');
        } else {
          minutesArchiveYearButton.children[1].classList.add('open');
        }
      })
      
      // Rotate the month chevron when toggling the information
      $('button.minutes-archive-month').on('click', (e) => {
        var minutesArchiveMonthButton;
        
        if ( e.target.tagName === 'BUTTON' ) {
          minutesArchiveMonthButton = e.target;
        } else {
          minutesArchiveMonthButton = e.target.parentElement;
        }
        
        if ( minutesArchiveMonthButton.children[1].classList.contains('open') ) {
          minutesArchiveMonthButton.children[1].classList.remove('open');
        } else {
          minutesArchiveMonthButton.children[1].classList.add('open');
        }
      })
    }

    // Events single page
    let singleEvent = document.getElementsByClassName('single-events');
    let singleNewsItem = document.getElementsByClassName('single-news-post-type');
    
    function adjustSidebarHeight() {
      if ( window.innerWidth >= 1080 ) {
        // Get the date and the title
        const dateElement = document.querySelector('article .item-date');
        const titleElement = document.querySelector('article .item-title');
        
        // Get the date and title elements' heights
        const dateHeight = dateElement.offsetHeight + parseFloat(window.getComputedStyle(dateElement).marginBottom);
        const titleHeight = titleElement.offsetHeight + parseFloat(window.getComputedStyle(titleElement).marginBottom);

        // Get the sidebar and add it to align the sidebar with the content/image
        let sidebar = document.querySelector('aside');
        sidebar.style.marginTop = dateHeight + titleHeight + 'px';
      }
    }
    
    if ( singleEvent.length || singleNewsItem.length ) {
      $(document).ready(adjustSidebarHeight);

      $(window).resize(adjustSidebarHeight);
    }
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js